import { useEffect, useState, useRef } from 'react'
import { appKanbanUserList, appSubmission, getBranches, getCompanies, getDesignations, getUserOpportunitiesList, getUserPipelines, registeredUserList, updateUserStage } from '../../utils/urls';
import axios from '../../utils/axios'
// import CampaignTable from '../../components/campaigns/CampaignTable';
import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import OnboardedUsersTable from '../../components/Leaders/OnboardedUsersTable';
import { Button } from 'primereact/button';
import useDebounce from '../../components/apps/appsKanban/hooks/useDebounce';
import FlexComponent from '../../components/FlexComponent';
import UserSectionList from '../../components/apps/usersKanban/UserSectionList';
import { InputText } from 'primereact/inputtext';
import adminLogo from '../../Images/admin_img.jpg'
import { Toast } from 'primereact/toast';
import { CancelToken } from 'axios'
import { ToggleButton } from 'primereact/togglebutton';

const OnboardedUsers = () => {
    // const {userId} = useParams();
    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const image = useSelector((state) => state.user.image);
    const userId = useSelector((state) => state.user.userId);
    const [designationList, setDesignationList] = useState([])
    const [brancheList, setBranchList] = useState([])
    const [companiesList, setCompaniesList] = useState([])

    const [searchParams, setSearchParams] = useSearchParams();
    const options = ['Board', 'Table'];
    const [page, setPage] = useState(searchParams.get('section') === 'table' ? 'Table' : options[0])

    const [loading, setLoading] = useState(false)
    const cancelTokenRef = useRef(null);
    const toast = useRef(null);
    const [isMounted, setIsMounted] = useState(false)

    const [pipelineId, setPipelineId] = useState(1)
    const [boardSections, setBoardSections] = useState({
        "⏲️ Waiting/Follow Up": [],
        "🤳 Self-Serve Quick App": [],
        "📃✨ New Application": [],
        "🤖 Auto Doc Request": [],
        "🔥 Prequalified Awaiting Docs": [],
        "📄 Docs in - Active Client": [],
        "✅ Preapproved": [],
        "🛒Shopping": [],
        "📈 Refi": [],
        "✅ Active Loan": []
    });
    const [pipeline, setPipeline] = useState('')
    const [stageIds, setStageIds] = useState({})
    const [stageAppCounts, setStageAppCounts] = useState({})
    const [usersList, setUsersList] = useState([])
    const [registeredUsersList, setRegisteredUsersList] = useState([])

    // const [incomeRangeValue, setIncomeRangeValue] = useState([0, 1000000])
    // const { searchQuery, setSearchQuery } = useDebounce(handleSearch, setLoading);
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 300);

    // const options = ['Board', 'Table', 'Archived'];
    // const [value, setValue] = useState(options[0]);
    // const [page, setPage] = useState(table ? options[1] : options[0])
    // const op = useRef(null);
    const [total, setTotal] = useState(0);
    const [isActive, setIsActive] = useState(true)


    const getAllDesignations = () => {
        const url = `${getDesignations}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setDesignationList(response.data)

                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })
    }

    const getAllBranches = () => {
        const url = `${getBranches}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setBranchList(response.data)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })
    }

    const getAllCompanies = () => {
        const url = `${getCompanies}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setCompaniesList(response.data)
                    // setLoading(false)
                }
            })
            .catch((error) => {
                // setLoading(false)
            })
    }

    const getAllLocations = () => {
        const url = `${getCompanies}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    setCompaniesList(response.data)
                    // setLoading(false)
                }
            })
            .catch((error) => {
                // setLoading(false)
            })
    }

    useEffect(() => {
        getAllDesignations()
        getAllBranches()
        getAllCompanies()
    }, [userId])

    const handleStageUpdate = (user_id, stage, prevStage) => {
        console.log(stage, prevStage)
        const data = {
            // stage: stage,
            userId: userId,
            stage_id: stageIds[stage],
            // email_list: emails
        }
        const stageUrl = `${updateUserStage}${user_id}`
        axios.post(stageUrl, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Successfully Updated', life: 3000 });
                    // handleSearch()
                    setStageAppCounts(prevCounts => ({
                        ...prevCounts,
                        [stage]: prevCounts[stage] + 1,
                        [prevStage]: prevCounts[prevStage] - 1
                    }))
                    const url = `${appSubmission}${user_id}?pipelineId=${pipelineId}`
                    axios.get(url, {
                        headers: { 'Content-Type': 'application/json' }
                    })
                        .then((response) => {
                            if (response.status === 200) {
                                // console.log(response.data)
                                const data = response.data
                                setBoardSections(prevSections => {
                                    const updatedSections = { ...prevSections };
                                    for (const sectionId in updatedSections) {
                                        updatedSections[sectionId] = updatedSections[sectionId].map(item => {
                                            if (item.user_id === user_id) {
                                                return {
                                                    ...item,
                                                    due_date: data.due_date
                                                };
                                            }
                                            return item;
                                        });
                                    }
                                    return updatedSections;
                                });
                            }
                        })

                }
                else if (response.status === 208) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.data, life: 3000 });
                    handleSearch()
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    handleSearch()
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                handleSearch()
            })
    }

    const getAllPipelines = () => {
        if (pipelineId) {
            const url = `${getUserPipelines}?userId=${userId}`
            axios.get(url, {
                headers: { 'Content-Type': 'application/json' }
            })
                .then((response) => {
                    if (response.status === 200) {
                        console.log(response.data)
                        const item = response?.data?.find(item => item.id == pipelineId);
                        console.log("item", item)
                        setPipeline(item)
                    }
                })
                .catch((error) => {
                    // setAppLeads(null)
                })
        }
    }


    const handleSearch = () => {
        if (userId && pipelineId) {
            setLoading(true)
            if (cancelTokenRef.current) {
                cancelTokenRef.current.cancel('Operation canceled due to new request.');
            }
            cancelTokenRef.current = CancelToken.source();

            // const users = selectedUsers?.join(',')
            getAllPipelines()
            const url = `${getUserOpportunitiesList}?userId=${userId}&pipelineId=${pipelineId}&search=${searchQuery}&sort=DESC&isActive=${isActive}`

            axios.get(url, {
                headers: { 'Content-Type': 'application/json' },
                cancelToken: cancelTokenRef.current.token
            })
                .then((response) => {
                    if (response.status === 200) {
                        setLoading(true)
                        // console.log(response.data)
                        const stagesData = response.data.stages
                        const stagesCount = response.data.counts
                        const stageIdsData = response.data.stage_ids
                        const stageWatchersData = response.data.watchers
                        const updatedData = Object.keys(stagesData).reduce((acc, key) => ({
                            ...acc,
                            [key]: stagesData[key]?.map(item => ({ ...item, id: item.user_id }))
                        }), {});

                        setBoardSections(updatedData)
                        setStageAppCounts(stagesCount)
                        setTotal(Object.values(stagesCount).reduce((sum, count) => sum + count, 0))
                        setStageIds(stageIdsData)
                        // setStageWatchers(stageWatchersData)
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    // setAppLeads(null)
                })
        }
    };



    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const loadUsersData = () => {
        const url = `${appKanbanUserList}?userId=${userId}`
        axios.get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setUsersList(options)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })

        const registeredUsersUrl = `${registeredUserList}`
        axios.get(registeredUsersUrl, {
            headers: { 'Content-Type': 'application/json' }
        })
            .then((response) => {
                if (response.status === 200) {
                    // console.log(response.data)
                    const options = response?.data?.map((user) => ({
                        label: user.name,
                        value: user.user_id,
                        image: user.image
                    })) || [];
                    setRegisteredUsersList(options)
                }
            })
            .catch((error) => {
                // setAppLeads(null)
            })

    };

    const clearFilters = () => {
        setSearchQuery('');
        setLoading(true)
        handleSearch()
    }

    useEffect(() => {
        if (userId && pipelineId) {
            setLoading(true)
            handleSearch()
        }
    }, [userId, isMounted, pipelineId, debouncedSearchQuery, isActive])

    useEffect(() => {
        if (userId) {
            loadUsersData()
        }
    }, [userId])



    return (
        <>
            <Toast ref={toast} />
            <div
                className='kanbanContainer'
                style={{
                    paddingBottom: '2rem',
                    backgroundImage: `url("${isSuperuser ? adminLogo : image}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '100vh',
                    position: 'relative' // Needed for overlay positioning
                }}
            >
                <div
                    className='table-inner-div'
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: 0 // Below content
                    }}
                />
                <FlexComponent style={{paddingTop: "1rem"}} justifyContent="end" alignItems="center" >
                    {page === 'Board' && <Button className='piplelineTitle' style={{ cursor: "auto", color: "white", background: "transparent", boxShadow: "none", border: "none", width: "30%", fontSize: "20px", fontWeight: "bold" }} >{pipeline.name} {!loading && `- ${total}`}</Button>}

                    {page === 'Board' && <ToggleButton onLabel="Active" offLabel="InActive" style={{color:"white", marginRight: "1rem", border: "none", background : isActive ? "green" : "grey", padding: "3px 15px 3px 15px" }} checked={isActive} onChange={(e) => setIsActive(e.value)}  /> }

                    {page === 'Board' && <FlexComponent className='applicantDivs' style={{ width: "25%", marginRight: "2rem" }} >
                        <p style={{ color: "white", marginBottom: ".5rem" }} >Search</p>
                        <span className="p-input-icon-left " >
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder='Enter a Keyword...' onChange={handleSearchChange} value={searchQuery} style={{ color: 'black' }} />
                        </span>
                    </FlexComponent>}
                    <div style={{ marginRight: "2rem" }} >
                        {<Button style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0", fontWeight: "600", background: page === 'Board' ? '#06243B' : 'white', color: page === 'Board' ? 'white' : 'black' }} onClick={() => {
                            setPage('Board')
                            setSearchParams({})
                            handleSearch()
                        }}>Board</Button>}
                        <Button style={{ borderTopLeftRadius: "0", borderBottomLeftRadius: "0", fontWeight: "600", background: page === 'Table' ? '#06243B' : 'white', color: page === 'Table' ? 'white' : 'black' }} onClick={() => {
                            setPage('Table')
                            setSearchParams({ section: 'table' })
                        }}>Table</Button>
                    </div>
                </FlexComponent>

                {page === 'Board' ?
                    <FlexComponent flexDirection="column" justifyContent="end" alignItems="end" >
                        <FlexComponent flexDirection="column" className='applicant-cards' alignItems='start' gap="0.2rem" style={{ zIndex: '1' }}  >
                            <FlexComponent flexDirection='column' style={{ gap: '2rem', zIndex: '1', width: 'auto' }}>
                                <UserSectionList key={loading} toast={toast} userId={userId} pipeline={pipeline} isActive = {isActive} usersList={registeredUsersList} setTotal={setTotal} stageAppCounts={stageAppCounts} stageIds={stageIds} setStageAppCounts={setStageAppCounts} boardSections={boardSections} setBoardSections={setBoardSections} handleStageUpdate={handleStageUpdate} searchQuery={searchQuery} isMounted={isMounted} setIsMounted={setIsMounted} loading={loading} />
                            </FlexComponent>
                        </FlexComponent>
                    </FlexComponent>

                    : <OnboardedUsersTable designationList={designationList} branchesList={brancheList} companiesList={companiesList} />
                }
                {/* <div className='table-container'>
                    <OnboardedUsersTable designationList={designationList} companiesList={companiesList} />
                </div> */}
            </div>
        </>
    );
}
export default OnboardedUsers;